export const formatDuration = (minutes: number): string => {
  if (minutes >= 60) {
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    return remainingMinutes > 0 ? `${hours}h ${remainingMinutes}m` : `${hours}h`;
  }
  return `${minutes}m`;
};

export const formatDurationForRewards = (minutes: number): string => {
  if (minutes >= 60) {
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;

    if (remainingMinutes > 0) {
      return `${hours} hour${hours > 1 ? 's' : ''} ${remainingMinutes} min`;
    }
    return `${hours} hour${hours > 1 ? 's' : ''}`;
  }
  return `${minutes} min`;
};

export const formatMultiplier = (multiplier: number): string => {
  const percentage = Math.round(multiplier * 100);
  return `${percentage}%`;
};

const formatToNearestX = (number: number, nearest: number, floor = true) => {
  if (number < nearest) {
    return number.toLocaleString();
  }
  const rounded = floor ? Math.floor(number / nearest) * nearest : Math.ceil(number / nearest) * nearest;
  const formatted = Intl.NumberFormat('en', { notation: 'compact' }).format(rounded);
  return Intl.NumberFormat('en', { notation: 'compact' }).format(rounded);
};

export const formatToNearest50 = (number: number) => {
  return formatToNearestX(number, 50);
};

export const formatToNearest500K = (number: number) => {
  return formatToNearestX(number, 500000);
};
